import { SectionContainer, SectionContent } from 'builder/components/ProfileSummary/styles'
import {
  SectionBodyFoldableContainer,
  SectionHeader,
  SectionHeaderFoldableContainer,
  SectionHint,
  useFoldableSectionHandlers,
} from 'builder/components/Section'
import SectionTitle from 'builder/components/SectionTitle'
import RichTextArea from 'builder/components/RichTextArea/RichTextArea'
import { useUpdateSimpleShokomuField } from 'builder/hooks/useUpdateSimpleShokumuField'
import { SectionNames } from 'builder/modules/resumeEditor'
import { useShokumuTranslations } from '../../useShokumuTranslations'

export const Motivation = (): JSX.Element => {
  const { fieldValue, updateField } = useUpdateSimpleShokomuField('motivation')
  const { i18n } = useShokumuTranslations()
  const title = i18n('motivation.title')
  const hint = i18n('motivation.hint')
  const { isOpened, handleToggle } = useFoldableSectionHandlers(SectionNames.motivation)

  return (
    <SectionContainer>
      <SectionHeader isOpened={isOpened} onClick={handleToggle}>
        <SectionTitle title={title} isOpened={isOpened} />
        <SectionHeaderFoldableContainer isOpened={isOpened}>
          <SectionHint>{hint}</SectionHint>
        </SectionHeaderFoldableContainer>
      </SectionHeader>
      <SectionBodyFoldableContainer isOpened={isOpened}>
        <SectionContent>
          <RichTextArea
            height={96}
            boldButtonDisable
            italicButtonDisable
            linkButtonDisable
            value={fieldValue as string}
            onChange={updateField}
          />
        </SectionContent>
      </SectionBodyFoldableContainer>
    </SectionContainer>
  )
}
